import './SearchLinkToResult.svelte.css';
/* src/components/searchResult/SearchLinkToResult.svelte generated by Svelte v3.46.4 */
import {
	SvelteComponent,
	attr,
	component_subscribe,
	detach,
	element,
	empty,
	init,
	insert,
	noop,
	safe_not_equal
} from "../../../_snowpack/pkg/svelte/internal.js";

import { searchResult } from '../../stores/storeSearchResult.js';

function create_if_block(ctx) {
	let div;

	return {
		c() {
			div = element("div");
			div.innerHTML = `<a href="#lit-search-panel">searchbox ▲</a>`;
			attr(div, "class", "to-search-body svelte-mx9z74");
		},
		m(target, anchor) {
			insert(target, div, anchor);
		},
		d(detaching) {
			if (detaching) detach(div);
		}
	};
}

function create_fragment(ctx) {
	let if_block_anchor;
	let if_block = /*$searchResult*/ ctx[0] && /*$searchResult*/ ctx[0].item && 4 < /*$searchResult*/ ctx[0].item.length && create_if_block(ctx);

	return {
		c() {
			if (if_block) if_block.c();
			if_block_anchor = empty();
		},
		m(target, anchor) {
			if (if_block) if_block.m(target, anchor);
			insert(target, if_block_anchor, anchor);
		},
		p(ctx, [dirty]) {
			if (/*$searchResult*/ ctx[0] && /*$searchResult*/ ctx[0].item && 4 < /*$searchResult*/ ctx[0].item.length) {
				if (if_block) {
					
				} else {
					if_block = create_if_block(ctx);
					if_block.c();
					if_block.m(if_block_anchor.parentNode, if_block_anchor);
				}
			} else if (if_block) {
				if_block.d(1);
				if_block = null;
			}
		},
		i: noop,
		o: noop,
		d(detaching) {
			if (if_block) if_block.d(detaching);
			if (detaching) detach(if_block_anchor);
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let $searchResult;
	component_subscribe($$self, searchResult, $$value => $$invalidate(0, $searchResult = $$value));
	return [$searchResult];
}

class SearchLinkToResult extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, {});
	}
}

export default SearchLinkToResult;